<template>
  <div
    v-for="(item, index) in props.dataSource"
    :key="item.id"
    class="publisher-item"
    @click="goToPublisherDetail(item)"
    :style="{ cursor: props.disabled ? 'default' : 'pointer' }"
  >
    <div class="publisher-info">
      <div class="creator-info">
        <LogoImage
          :maxWidth="'95%'"
          :logoUrl="item?.publicImage"
          :brandName="item?.creatorName"
          :width="136"
          :height="136"
          :fontSize="16"
        />
        <div class="info">
          <div class="info-item mb-20">
            <div class="name">{{ item?.creatorName }}</div>
          </div>
          <div class="info-item-middle mb-20">
            <div class="info-item">
              <div class="label">{{ $t('seller.brandsPage.colPromotionCountries') }}:</div>
              <a-tooltip
                v-if="shouldShowTooltip(`item-${item.id}-promotion-countries`)"
                placement="top"
                overlayClassName="wide-tooltip"
                :title="getFullText(item?.promotionCountries)"
              >
                <div
                  class="value product-categories-value"
                  :data-overflow-check="`item-${item.id}-promotion-countries`"
                >
                  {{
                    item?.promotionCountries
                      ? getComputedData(item?.promotionCountries)
                      : '--'
                  }}
                </div>
              </a-tooltip>
              <div
                v-else
                class="value product-categories-value"
                :data-overflow-check="`item-${item.id}-promotion-countries`"
                :style="{
                  color: item?.promotionCountries ? '' : 'rgba(15, 6, 41, 0.3)',
                }"
              >
                {{
                  item?.promotionCountries
                    ? getComputedData(item?.promotionCountries)
                    : '--'
                }}
              </div>
            </div>
            <div class="info-item">
              <div class="label">{{ $t('seller.brandsPage.colPromotionMethod') }}:</div>
              <a-tooltip
                v-if="shouldShowTooltip(`item-${item.id}-promotion-methods`)"
                placement="top"
                overlayClassName="wide-tooltip"
                :title="getFullText(item?.promotionMethods)"
              >
                <div
                  class="value product-categories-value"
                  :data-overflow-check="`item-${item.id}-promotion-methods`"
                >
                  {{
                    item?.promotionMethods
                      ? getComputedData(item?.promotionMethods)
                      : '--'
                  }}
                </div>
              </a-tooltip>
              <div
                v-else
                class="value product-categories-value"
                :data-overflow-check="`item-${item.id}-promotion-methods`"
                :style="{
                  color: item?.promotionMethods ? '' : 'rgba(15, 6, 41, 0.3)',
                }"
              >
                {{
                  item?.promotionMethods
                    ? getComputedData(item?.promotionMethods)
                    : '--'
                }}
              </div>
            </div>

            <div class="info-item">
              <div class="label">{{ $t('seller.brandsPage.colProductCategories') }}:</div>
              <a-tooltip
                v-if="shouldShowTooltip(`item-${item.id}-product-categories`)"
                placement="top"
                overlayClassName="wide-tooltip"
                :title="getFullText(item?.promotionProductCategories)"
              >
                <div
                  class="value product-categories-value"
                  :data-overflow-check="`item-${item.id}-product-categories`"
                >
                  <span
                    :style="{
                      color: item?.promotionProductCategories
                        ? ''
                        : 'rgba(15, 6, 41, 0.3)',
                    }"
                  >
                    {{
                      item?.promotionProductCategories
                        ? getComputedData(item?.promotionProductCategories)
                        : '--'
                    }}
                  </span>
                </div>
              </a-tooltip>
              <div
                v-else
                class="value product-categories-value"
                :data-overflow-check="`item-${item.id}-product-categories`"
                :style="{
                  color: item?.promotionProductCategories
                    ? ''
                    : 'rgba(15, 6, 41, 0.3)',
                }"
              >
                {{
                  item?.promotionProductCategories
                    ? getComputedData(item?.promotionProductCategories)
                    : '--'
                }}
              </div>
            </div>
          </div>

          <div class="info-item mb-20">
            <div class="label">{{ $t('seller.brandsPage.colBio') }}:</div>
            <a-tooltip
              v-if="shouldShowTooltip(`item-${item.id}-bio`)"
              overlayClassName="wide-tooltip"
              placement="top"
              :title="item?.publicBio || '--'"
            >
              <div
                class="value product-categories-value value-no-bold"
                :data-overflow-check="`item-${item.id}-bio`"
              >
                <span>
                  {{ item?.publicBio ? item?.publicBio : '--' }}
                </span>
              </div>
            </a-tooltip>
            <div
              v-else
              class="value value-no-bold product-categories-value"
              :data-overflow-check="`item-${item.id}-bio`"
              :style="{ color: item?.publicBio ? '' : 'rgba(15, 6, 41, 0.3)' }"
            >
              {{ item?.publicBio ? item?.publicBio : '--' }}
            </div>
          </div>
          <div
            class="program-status mb-20"
            ref="associateProgramRef"
            v-if="props.hasAvailablePrograms"
          >
            <div class="label mb-4">{{ $t('seller.publishersPage.availablePrograms') }}</div>

            <!-- Amazon Associate -->
            <div class="info-item">
              <a-tooltip
                overlayClassName="associate-tooltip"
                placement="top"
                :autoAdjustOverflow="false"
                :overlayStyle="{ marginBottom: '2px' }"
                :arrowPointAtCenter="true"
              >
                <template #title> {{ $t('seller.publishersPage.tooltipAmazonAdsAttribution') }} </template>
                <div class="item">
                  <img
                    src="../../../../assets/images/img/AT@2x.png"
                    alt=""
                    class="icon"
                  />
                  <span class="item-text">{{ $t('seller.publishersPage.labelAttribution') }}</span>
                </div>
              </a-tooltip>
              <!-- <a-tooltip
                overlayClassName="associate-tooltip"
                placement="top"
                :autoAdjustOverflow="false"
                :overlayStyle="{ marginBottom: '2px' }"
                :arrowPointAtCenter="true"
              >
                <template #title>
                  {{
                    item?.associateBrandCount
                      ? $t('seller.publishersPage.tooltipBrandsInPartnership', { count: item.associateBrandCount })
                      : $t('seller.common.amazonAssociate')
                  }}
                </template>
                <div class="item" v-if="item?.associateEnabled">
                  <img
                    src="../../../../assets/images/img/AS@2x.png"
                    alt=""
                    class="icon"
                  />
                  <span class="item-text"
                    >{{
                      item?.associateBrandCount
                        ? $t('seller.publishersPage.brandsCountShort', { count: item.associateBrandCount })
                        : $t('seller.publishersPage.labelAssociateShort')
                    }}
                  </span>
                </div>
              </a-tooltip> -->

              <!-- Connections -->
              <!-- <a-tooltip overlayClassName="associate-tooltip" placement="top" :autoAdjustOverflow="false"
                :overlayStyle="{ marginBottom: '2px' }" :arrowPointAtCenter="true">
                <template #title>
                  Amazon Creator Connections
                </template>
                <div class="item">
                  <img src="../../../../assets/images/img/CC@2x.png" alt="" class="icon">
                  <span class="item-text">Connections</span>
                </div>
              </a-tooltip> -->
            </div>
          </div>
          <div
            class="program-status"
            style="
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
            "
          >
            <div>
              <div class="label mb-4">{{ $t('seller.publishersPage.links') }}:</div>

              <!-- Amazon Associate -->
              <div class="info-item">
                <template
                  v-for="link in item.links"
                  :key="link.id"
                  v-if="item.links && item.links.length > 0"
                >
                  <div
                    class="item"
                    @click.stop="goToLink(link)"
                    v-if="link.url"
                  >
                    <svg-icon
                      class="icon-app-default"
                      name="lianjie"
                      style="font-size: 12px; padding: 4px"
                      v-if="
                        link.name === 'Other' || link.name === 'Website/Blog'
                      "
                    />
                    <svg-icon
                      :name="link?.name?.toLowerCase()"
                      class="icon-app"
                      v-else
                    />
                    <span class="item-text">{{ link.name }}</span>
                    <svg-icon name="jiantou-you-cu" style="color: #0f0629" />
                  </div>
                </template>
                <template v-else>
                  <div style="color: rgba(15, 6, 41, 0.3)">
                    <span>--</span>
                  </div>
                </template>
              </div>
            </div>
            <!-- <div v-if="props.showAssociatePartnership">
              <artmisads-select-button
                type="primary"
                v-if="item?.associateEnabled"
                @click.stop="setUpAssociatePartnership(item)"
                >Set Up Associate Partnership</artmisads-select-button
              >
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <setPartnershipModal ref="setPartnershipModalRef" @refresh='refreshList' />
  <artmisads-modal :maskClosable="false" :footer="null" v-model:open="visible">
      <div class="modal-content">
        {{ $t('seller.publishersPage.allBrandsPartneredBody') }}<a style="text-decoration: underline;" @click="handleSetUp">{{ $t('seller.publishersPage.viewNow') }}</a>
      </div>
  </artmisads-modal>
</template>

<script setup>
import {
  defineProps,
  computed,
  ref,
  onMounted,
  nextTick,
  watch,
  onUnmounted,
  defineEmits
} from 'vue'
import LogoImage from '@/components/LogoImage.vue'
import debounce from 'lodash/debounce'
import SvgIcon from '~/components/SvgIcon.vue'
import { publishersApi } from '@/server'
import { countBrandNames } from '~/utils'
import setPartnershipModal from '~/components/setPartnership.vue'
const itemValue=ref({})
const visible=ref(false)
const setPartnershipModalRef=ref(null)
const emit=defineEmits(['refresh'])
const props = defineProps({
  dataSource: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hasAvailablePrograms: {
    type: Boolean,
    default: true,
  },
  showAssociatePartnership: {
    type: Boolean,
    default: false,
  },
})
const associateProgramRef = ref(null)
const refreshList = () => {
  emit('refresh')
}
// 暴露 associateProgramRef 给父组件
defineExpose({
  associateProgramRef,
  // 添加一个方法来获取所有 associateProgramRef
  getAllAssociateProgramRefs: () => {
    return document.querySelectorAll('.program-status')
  },
})
// 存储每个字段是否溢出的状态
const overflowStates = ref({})

// 检查单个元素是否溢出
const checkOverflow = (element) => {
  if (!element) return false
  // 当scrollHeight大于clientHeight时，说明内容溢出了
  return element.scrollHeight > element.clientHeight
}

// 检查所有元素的溢出状态
const checkAllOverflow = async () => {
  await nextTick()
  const newStates = {}

  // 查找所有带有data-overflow-check属性的元素
  const elements = document.querySelectorAll('[data-overflow-check]')
  elements.forEach((element) => {
    const key = element.getAttribute('data-overflow-check')
    newStates[key] = checkOverflow(element)
  })

  overflowStates.value = newStates
}

// 简单的判断方法：是否应该显示tooltip
const shouldShowTooltip = (key) => {
  return overflowStates.value[key] || false
}
const goToLink = (link) => {
  if (!link.url) {
    return
  }
  window.open(link.url, '_blank')
}
// 获取完整的文本内容
const getFullText = (item) => {
  if (!item) return '--'
  if (Array.isArray(item)) {
    if (item.length > 0) {
      return item.map((i) => i.name).join(', ')
    }
    return '--'
  }
  return '--'
}

// 创建防抖版本的checkAllOverflow函数
const debouncedCheckOverflow = debounce(checkAllOverflow, 200)

onMounted(() => {
  // 延迟执行，确保DOM完全渲染
  setTimeout(() => {
    checkAllOverflow()
  }, 100)

  // 监听窗口大小变化
  window.addEventListener('resize', debouncedCheckOverflow)
})

// 组件卸载时清理事件监听器
onUnmounted(() => {
  window.removeEventListener('resize', debouncedCheckOverflow)
})
 const handleSetUp=()=>{
  goToPublisherDetail(itemValue.value)
}
// 监听数据变化
watch(
  () => props.dataSource,
  () => {
    // 防抖延迟执行
    setTimeout(() => {
      checkAllOverflow()
    }, 200)
  },
  { deep: true }
)
const setUpAssociatePartnership = (item) => {
 itemValue.value = item
  const requestParams = {
    publisherId: item.id,
    page: 1,
    size: 1000,
  }
  let daraList = []
  publishersApi.getPublisherDetail(requestParams).then((res) => {
    if (res.success) {
      const brandNameCount = countBrandNames(
        res.data?.data,
        'brandVO.amazonBrandName',
      )
      daraList = res.data?.data?.map((item, index) => {
        return {
          ...item.brandVO,
          nextMonthCommissionDetail: item.nextMonthCommissionDetail,
          status: item.status,
          startDateStr: item.startDateStr,
          endDateStr: item.endDateStr,
          publisherId: item.publisherId,
          brandId: item.brandId,
          commissionRate: item?.currentCommissionDetail?.commissionRate,
          lastCommissionRate: item?.lastCommissionRate,
          hasDuplicate:
            item.brandVO.amazonBrandName &&
            brandNameCount[item.brandVO.amazonBrandName] > 1,
        }
      })
      const inactiveSelectedRowKeys = daraList.filter(
        (item) => item.status === 'inactive',
      )
      if (inactiveSelectedRowKeys.length === 0) {
        visible.value = true
        return
      }
      const param = {
        id: item.id,
        creatorName: item.creatorName,
        publicImage: item.publicImage,
        type: 'brands',
        inactiveSelectedRowKeys: inactiveSelectedRowKeys,
        selectType: 'single',
      }
      // setPartnershipModalRef.value.show(
      //   item.id,
      //   item.creatorName,
      //   item.creatorName,
      //   item.publicImage,
      //   'brands',
      //   inactiveSelectedRowKeys,
      //   'single'
      // )
      // return
      // setPartnershipModalRef.value.show()
      sessionStorage.setItem('publisherDetail', JSON.stringify(param))
      window.open(
        `/seller/associateCentral/setUpAssociatePartnership?id=${item.id}&isAcc=false`,
        '_blank',
      )
    }
  })
}

// 方法2：使用computed工厂函数
const getComputedData = (item) =>
  computed(() => {
    if (Array.isArray(item)) {
      if (item.length > 0) {
        return item.map((item) => item.name).join(',')
      } else {
        return '--'
      }
    } else {
      return '--'
    }
  })

function goToPublisherDetail(item) {
  if (props.disabled) {
    return
  }
  const data = {
    id: item.id,
    creatorName: item.creatorName,
    publicImage: item.publicImage,
    promotionCountries: item.promotionCountries,
    promotionMethods: item.promotionMethods,
    promotionProductCategories: item.promotionProductCategories,
    publicBio: item.publicBio,
    associateBrandCount: item.associateBrandCount,
    associateEnabled: item.associateEnabled,
    links: item.links,
  }
  sessionStorage.setItem('publisherDetail', JSON.stringify(data))
  window.open(`/seller/publishers/${item.id}`, '_blank')
}
</script>
<style>
.wide-tooltip .ant-tooltip-inner {
  margin-left: -80px;
  min-width: 400px !important;
  white-space: normal !important;
  word-break: break-word !important;
}
</style>
<style scoped lang="less">
.publisher-table {
  // width: 100%;
}
.modal-content{
  padding: 12px;
}
.associate-tooltip {
  margin-bottom: 2px !important;
  transform: translateY(13px) !important;
}

.publisher-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.publisher-item {
  display: block;
  padding: 16px;
  gap: 20px;
  flex: 1 0 0;
  border-radius: 8px;
  background: #F8F7FC;
 
}

.publisher-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
}

.creator-info {
  display: flex;
  gap: 16px;
  height: 100%;

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .info-item-middle {
    display: flex;
    gap: 16px;
    justify-content: space-between;
    align-items: stretch;

    .info-item {
      flex: 1;
    }
  }

  .creator-name {
    font-size: 18px;
    font-weight: 600;
    color: var(--text-color);
  }
}

.program-status {
  .info-item {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  // .item:not(:first-child):not(:last-child) {
  //   margin: 0 5px;
  // }
  .icon-app {
    font-size: 20px;
    border-radius: 4px;
    overflow: hidden;
    background-color: var(--bg-gray-5);
  }
  .icon-app-default {
    font-size: 16px;
    padding: 2px;
    border-radius: 4px;
    overflow: hidden;
    background-color: var(--bg-gray-5);
    color: var(--dark-4);
  }
  .item {
    display: flex;
    padding: 3px 4px;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    background: #f1f0f5;

    .icon {
      width: 20px !important;
      height: 20px !important;
    }

    .item-text {
      color: #0f0629;
      font-family: 'Sora';
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.3px;
      opacity: 0.7;
    }
  }
}

.label {
  color: #0f0629;
  opacity: 0.5;
  font-family: 'Sora';
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.value {
  color: #0f0629;
  font-family: 'Sora';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.4px;
  word-break: break-word;
}

.value-no-bold {
  font-weight: normal !important;
}

.name {
  color: #0f0629;
  font-family: 'Sora';
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.4px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-4 {
  margin-bottom: 2px;
}

.product-categories-value {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
}

.status-tag {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;

  &.available {
    background-color: var(--success-color-bg);
    color: var(--success-color);
  }

  &.unavailable {
    background-color: var(--error-color-bg);
    color: var(--error-color);
  }
}

// @media screen and (max-width: 768px) {
//   .publisher-grid {
//     grid-template-columns: 1fr;
//   }

//   .creator-info {
//     .info {
//       grid-template-columns: 1fr;
//     }
//   }
// }
</style>
